import React, { useEffect, useState } from 'react';
import axios from 'axios';
import StudentView from '../../components/SuperAdmin/StudentView';

function Student() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(()=>{
    try{
      const fetchData = async () => {
        const result = await axios.post(`${process.env.REACT_APP_BASE_URL}/admin/get-all-users`, {type: "student"}, {withCredentials: true});
        setData(result.data.users);
      }
      fetchData();
      setLoading(false);
    }catch(e){
      console.log(e);
      setLoading(false);
    }
  }, []);

  if(loading) return <p>Loading...</p>
  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold mb-6 ml-5">Admin Dashboard</h1>
      <StudentView title={"Student"} data={data} />
    </div>
  )
}

export default Student